import { ActionType } from "../../../../../../react-core/Flux/ActionType";
import { CommonHelper } from "../../../../../../react-core/Helpers/CommonHelper";
import { OneOffIncomePaymentClient } from "../../../../../../Wrap/Api/Apply/OneOffIncomePayment";
import { PensionContributionInstructionClient } from "../../../../../../Wrap/Api/Apply/PensionContributionInstruction";
import { SubAccountAmendmentInstructionClient } from "../../../../../../Wrap/Api/Apply/SubAccountAmendmentInstruction";
import { DrawdownSinglePaymentInstructionClient } from "../../../../../../Wrap/Api/Drawdown/DrawdownSinglePaymentInstruction";
import { ProcessType } from "../../../../../../Wrap/Constants/Enums/Client/DashboardFilter/ProcessType";
import { DrawdownSinglePaymentInstruction } from "../../../../../../Wrap/Models/Domains/Drawdown/DrawdownSinglePaymentInstruction";
import { IncomePaymentOneOffDispatcher, IncomePaymentOneOffStore } from "../Store/Variable";

export class IncomePaymentOneOffAction {
    public static getInstruction(id, hierarchyId, subAccountHierarchyId, customerId): void {
        const oneOffIncomePaymentClient = new OneOffIncomePaymentClient();

        if (CommonHelper.isNullOrEmpty(id)) {
            oneOffIncomePaymentClient
                .post(subAccountHierarchyId, hierarchyId)
                .onSuccess((result) => {
                    const instructionId = result.Result;
                    const promise = oneOffIncomePaymentClient.get(instructionId, customerId, subAccountHierarchyId);

                    this.updateOneOffIncomeInstructionStore(promise);
                });
        } else {
            const promise = oneOffIncomePaymentClient.get(id, customerId, subAccountHierarchyId);

            this.updateOneOffIncomeInstructionStore(promise);
        }
    }

    public static createOneOffIncomeModel(subAccountAmendmendHierarchyId, subAccountHierarchyId, clientId) {
        const client = new DrawdownSinglePaymentInstructionClient();
        let instruction: DrawdownSinglePaymentInstruction = { HierarchyId: subAccountAmendmendHierarchyId, Payment: { TargetSpecificArrangements: true } }
        // Create new instruction
        const promise = client.post(subAccountHierarchyId, instruction);

        promise.onSuccess((result) => {
            const pensionContributionInstruction = new PensionContributionInstructionClient();
            const model = pensionContributionInstruction.get(subAccountAmendmendHierarchyId, clientId, "");

            this.updateOneOffIncomeInstructionStore(model);
        });
        promise.onError((error) => { });
    }

    public static saveInstruction(from, data: any, hierarchyId?: string, customerId?: number, subAccountHierarchyId?: string, callback?: (data) => void): void {
        const oneOffIncomePaymentClient = new OneOffIncomePaymentClient();
        let promise = oneOffIncomePaymentClient.put(data, hierarchyId, customerId, subAccountHierarchyId);
        promise.onSuccess((result) => {
            let data = JSON.parse(JSON.stringify(IncomePaymentOneOffStore.getData()));
            if (!data) { data = {}; }
            data = result;
            IncomePaymentOneOffDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: data,
            });
            if (result.Errors != null && result.Errors.length > 0) {
                callback(result.Errors.map((ele) => ele.UserMessage));
            } else {
                callback(result);
            }
        });

        promise.onError((err) => {
            IncomePaymentOneOffDispatcher.dispatch({
                actionType: ActionType.Error,
                payload: err,
            });
        });
    }

    public static submitInstruction(id, data, customerId, claccountId, callback?: (error) => void): void {
        const client = new SubAccountAmendmentInstructionClient();
        const promise = client.put(id, data, customerId, claccountId);
        promise.onSuccess((result) => {
            if (callback) { callback(result); }
        });

        promise.onError((err) => {
            IncomePaymentOneOffDispatcher.dispatch({
                actionType: ActionType.Error,
                payload: err,
            });
        });
    }

    private static updateOneOffIncomeInstructionStore(promise: any, callback?: (data) => void) {
        promise.onSuccess((result) => {
            let data = JSON.parse(JSON.stringify(IncomePaymentOneOffStore.getData()));
            if (!data) { data = {}; }
            data = result;
            IncomePaymentOneOffDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: data,
            });
            if (callback) { callback([]); }
        });

        promise.onError((err) => {
            IncomePaymentOneOffDispatcher.dispatch({
                actionType: ActionType.Error,
                payload: err,
            });
        });
    }
}
